export var random = Math.random;

export function setRandom(r) {
  random = r;
}



//////////////////
// WEBPACK FOOTER
// ./~/vega-statistics/src/random.js
// module id = 110
// module chunks = 0